exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#endModal .modal-content{background-color:rgba(0,0,0,0.0001) !important}#endModal .modal-backdrop.show{opacity:0.7 !important}.pretty{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.text{font-size:17px;font-weight:400;color:#FFFFFF}.text:hover{color:#FFFFFF}#body{color:#FFFFFF;text-align:center}#nice{font-size:26px;font-weight:900}#knock{font-size:18px}#successImage{width:350px;height:240px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/scss/component/tour.scss
// module id = 4001
// module chunks = 3